import styled from 'styled-components';
export var EmbedContainer = styled.div.attrs(function (_ref) {
  var _ref$aspectRatio = _ref.aspectRatio,
    _ref$aspectRatio2 = _ref$aspectRatio === void 0 ? {} : _ref$aspectRatio,
    _ref$aspectRatio2$x = _ref$aspectRatio2.x,
    _x = _ref$aspectRatio2$x === void 0 ? 16 : _ref$aspectRatio2$x,
    _ref$aspectRatio2$y = _ref$aspectRatio2.y,
    _y = _ref$aspectRatio2$y === void 0 ? 9 : _ref$aspectRatio2$y;
  return {
    aspectRatioOffset: _y / _x * 100
  };
}).withConfig({
  componentId: "sc-1ypf91o-0"
})(["position:relative;padding-bottom:", "%;height:", ";overflow:hidden;max-width:100%;& iframe{position:absolute;top:0;left:0;width:100%;height:100%;}"], function (props) {
  return props.aspectRatioOffset;
}, function (_ref2) {
  var fullHeight = _ref2.fullHeight;
  return fullHeight ? '100%' : '0';
});